<template>
  <el-dialog
    :title="'拒绝原因'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="20%"
  >
    <el-form
      :model="refundFrom"
      :rules="rules"
      ref="refundFrom"
      label-width="50"
      class="demo-refundFrom"
    >
      <el-form-item label="拒绝原因">
        <el-input
          placeholder="客户可见此原因"
          v-model.trim="refundFrom.denyReason"
          :rows="3"
          maxlength="50"
          show-word-limit
          type="textarea"
        ></el-input>
      </el-form-item>
      <div style="display: flex;gap:5px;flex-wrap: wrap;margin-bottom: 10px;">
        <el-tag class="quick" @click="setDenyReason"
          >用户未按衣物标识洗涤、烘干</el-tag
        >
        <el-tag class="quick" @click="setDenyReason">衣物太脏</el-tag>
      </div>

      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["refund"],
  data() {
    return {
      refundFrom: {
        id: this.refund ? this.refund.id : "",
        denyReason: this.refund ? this.refund.denyReason : ""
      },
      rules: {}
    };
  },
  methods: {
    submitForm() {
      console.log("--------------");
      console.log(this.refundFrom.denyReason);
      // if (this.refundFrom.remark == "") {
      //   alert("请输入内容！");
      //   return;
      // }
      let denyReasonModel = {
        id: this.refundFrom.id,
        denyReason: this.refundFrom.denyReason
      };
      this.$axios(this.$urlMapping["设置拒绝原因备注"], {
        data: denyReasonModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        this.$emit("closeForm");
        // this.$emit("onSubmit");
      });
    },
    closeForm() {
      console.log("close");
      this.$emit("closeForm");
    },

    setDenyReason(event) {
      const text = event.target.textContent;
      console.log(text);

      this.refundFrom.denyReason = text;
    }
  }
};
</script>

<style lang="less" scoped>
.quick {
  cursor: pointer;
}
</style>
